import { isValidRoute } from '@shared/constants/routes'
import { useMemo } from 'react'
import dompurify from 'isomorphic-dompurify'
import { useSearchQueryParams } from '@/features/shared/hooks/search'

export const useValidNextParam = () => {
  const { next = '' } = useSearchQueryParams()
  return useMemo(() => {
    if (!next || typeof next !== 'string') return
    const sanitizedNext = dompurify.sanitize(next)
    const [nextPath] = sanitizedNext.split('?')
    if (isValidRoute(nextPath || '')) return sanitizedNext
  }, [next])
}
